<gp-modal #entityDeleteAlertModal [closable]="true" size="sm">
  <div class="gp-modal-title">
    <h4
      class="text-ellipsis">{{ (isEmployeeReferencingAlert() ? 'DIALOG.entity_delete_alert_contract' : 'DIALOG.entity_delete_alert_ref_entity')| translate }}</h4>
  </div>
  <div class="gp-modal-body">
    <div class="list inset">
      <div *ngIf="isEmployeeReferencingAlert()">
        <div *ngFor="let employee of employeesList trackBy: trackByEmployeeId"
             class="list-item b-b">
          <div class="list-body">
            <div class="employee-name">
              <label>
                <gp-user-avatar
                  [pictureUri]="employee.photoLink?.href"
                  [initials]="(employee.firstName?.charAt(0) || '') + (employee.lastName?.charAt(0) || '') | uppercase"
                  size="sm">
                </gp-user-avatar>
                <span class="m-l-sm">{{ employee.lastName }} {{ employee.firstName }}</span>
              </label>
            </div>
            <small class="text-muted default-cursor">{{ 'DIALOG.contractIds' | translate }}: </small>
            <ng-container *ngFor="let contract of employee.contracts; let last = last">
              <small (click)="openEmployeeDetailCall(contract)" class="text-muted pointer hover-underline">
                {{ contract }}
              </small>
              <span *ngIf="!last"> - </span>
            </ng-container>
          </div>
        </div>
      </div>
      <div *ngIf="!isEmployeeReferencingAlert()">
        <div *ngFor="let entity of entityDTOList trackBy: trackByEntityId"
             class="list-item b-b">
          <div class="list-body">
            <div class="employee-name">
              <label>
                <gp-entity-avatar [value]="entity?.name"
                                  [textColor]="'white'"
                                  [bgColor]="entity?.searchFlagColour ? 'rgb(' + entity?.searchFlagColour + ')' : ''"
                                  [size]="'sm'">
                </gp-entity-avatar>
                <span class="m-l-sm">{{ entity.name | translate }}</span>
              </label>
            </div>
            <small class="text-muted default-cursor">{{ 'DIALOG.entityId' | translate }}: </small>
            <small (click)="openEntityDetailCall(entity)"
                   class="text-muted pointer hover-underline"> {{ entity.id }} </small>
            <small
              class="text-muted default-cursor">&nbsp;|&nbsp; {{ 'SETTINGS.user_rights.entity_tree_name' | translate }}
              : </small>
            <small class="text-muted default-cursor"> {{ entity.tree |translate }} </small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="gp-modal-footer">
    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button (click)="entityDeleteAlertModal.close()"
                class="btn btn-dark p-x-md"
                type="button">
          {{ 'FORM_GENERATOR.MODALS.BUTTONS.ok' | translate }}
        </button>
      </div>
    </div>
  </div>
</gp-modal>
